import industryExpertsExpertOfMonth from './contentfulExports/industryExpertsExpertOfMonth.json';

const useExpertsOfMonth = () => {
  return industryExpertsExpertOfMonth;
}

export default useExpertsOfMonth;
